<template>
  <div class="notice_details">
    <p class="title">
        <span>{{detailInfo.title}}</span>
        <el-button style='width:100px' type="primary" @click='back'>返回上级</el-button>
    </p>
    <p class="content">{{detailInfo.content}}</p>
    <p class="pdf_box" :style="{height:detailInfo.pdfUrl?'100vh':'auto'}">
      <embed class="pdf" :src="detailInfo.pdfUrl" alt />
    </p>
  </div>
</template>
<script>
export default {
  props: {
    detailInfo: {
      type: Object
    }
  },
  methods:{
      back(){
          this.$emit('hideDetail')
      }
  },
  computed: {

  }
};
</script>
<style lang="less" scoped>
.notice_details {
  color: #444;
  .title {
    font-size: 20px;
    font-weight: 600;
    display: flex;
    align-items: center;
    >span {
        flex:1;
    }
  }
  .content {
    width:80%;
    font-size: 16px;
    margin: 20px 0;
  }
  .pdf_box {
    width: 900px;
    margin-bottom: 20px;
    overflow: hidden;
  }
  .pdf {
    // -webkit-transform: translate(0, -50px);
    // transform: translate(0,0px);
    width: 900px;
    height: 100%;
  }
}
</style>